// extracted by mini-css-extract-plugin
export default {"form":"FormComment_form__sHRoe","textarea":"FormComment_textarea__UK9Nk","btn":"FormComment_btn__vqTU1"};